import { AnyAction } from 'redux';
import { fetchDesignAction } from '@/redux/designs/actions/fetchDesignAction';
import { getDesign } from '@/redux/designs/getters/getDesign';
import { Thunk } from '@/redux/types';
import { addDesignAction } from '@/components/draft/draftState/actions/addDesignAction';

export const addDesignConfigurationAction =
  (designId: string): Thunk<Promise<void>, AnyAction> =>
  async (dispatch, getState) => {
    let design = getDesign(getState(), designId);
    if (!design) {
      design = await dispatch(fetchDesignAction(designId));
    }

    getState().draftDispatch(addDesignAction(design));
  };
